import React from 'react';
import '../css/common.css';

function Footer(){
    return(
    <footer>
      <div className="inner">
        <div className="gobt">
        </div>

        <div className="fotinfo">
          <div className="info">
            <ul>
              <li>다드림 복지용구</li>
              <li>주소 : 대전 서구 한밭대로 570번길 33, 202호(갤러리빌 9차) | 대표자 : 이영미 | 개인정보보호책임자 : 이영미</li>
              <li>사업자등록번호: 439-32-01585</li>
              <li>TEL. 1533-5921 | E-mail. bc1592@naver.com</li>
              <li>COPYRIGHT (C) DADREAM. All right reserved.</li>
            </ul>
          </div>

          <div className="ftlog">
            <p>DADREAM</p>
          </div>
        </div>
      </div>
    </footer>
    );
}


export default Footer; 